import CryptoJS from 'crypto-js';
const UNSAFE_KEY = 'tradingblock';
export const encode = (source) => {
    return CryptoJS.AES.encrypt(JSON.stringify(source), UNSAFE_KEY).toString();
};
export const decode = (text) => {
    try {
        var bytes = CryptoJS.AES.decrypt(text, UNSAFE_KEY);
        const jsonStr = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(jsonStr);
    }
    catch (err) {
        return undefined;
    }
};
//# sourceMappingURL=jsonEncode.js.map